import request from '@/utils/http'

// 获取组织架构树:
function getTreeDataForOrganization () {
  return request({
    url: `organization/tree`,
    method: 'get'
  })
}

// 获取登录用户的子树 通常用在搜索选项:
function getTreeDataForSubOrganization () {
  return request({
    url: `organization/subTree`,
    method: 'get'
  })
}

// 更新组织架构到redis:
function saveOrganizationToRedis (params: any) {
  return request({
    url: `organization/saveOrganizationToRedis`,
    method: 'get'
  })
}

// 创建或修改组织架构节点:
function organizationSaveOrUpdate (params: any) {
  return request({
    url: `organization/saveOrUpdate`,
    method: 'post',
    data: { ...params }
  })
}

// 删除组织架构节点 删除1个节点之后要把挂在下面的人移动到另一个节点 所以要传2个参数:
function organizationDelete (params: any) {
  return request({
    url: `organization/delete`,
    method: 'delete',
    params
  })
}

// 获取学校：
function organizationGetSchool (params: any) {
  return request({
    url: `organization/getSchool`,
    method: 'get',
    params
  })
}

// 获取学校(新):
function organizationGetSchoolNew (params: any) {
  return request({
    url: `organization/getSchoolNew`,
    method: 'post',
    data: params
  })
}

export default {
  getTreeDataForOrganization,
  getTreeDataForSubOrganization,
  saveOrganizationToRedis,
  organizationSaveOrUpdate,
  organizationDelete,
  organizationGetSchool,
  organizationGetSchoolNew
}
